/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectTargetSummary } from './projectTargetSummary';
import { Report } from './report';
import { ProgramTargetSummaryReportAllOf } from './programTargetSummaryReportAllOf';


/**
 * Program target summary report
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgramTargetSummaryReport { 
    /**
     * Datetime that report data was materialized
     */
    readonly asOfDate?: string;
    /**
     * Target summary for Projects
     */
    readonly projectTargetSummaries: Array<ProjectTargetSummary>;

    constructor(item?: Partial<ProgramTargetSummaryReport>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            asOfDate: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.asOfDate : itemOrValue;

                    if (itemOrValue?.asOfDate != null) {
                        if (itemOrValue.asOfDate === '') {
                            itemOrValue.asOfDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.asOfDate = parseInt(itemOrValue.asOfDate.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.asOfDate = parseFloat(itemOrValue.asOfDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            projectTargetSummaries: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectTargetSummaries : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramTargetSummaryReport.isValid,
        };
    }

    static isValid(obj: ProgramTargetSummaryReport): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramTargetSummaryReport.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.asOfDate.isValid(item);
            result = result && validationObject.projectTargetSummaries.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

